import { constants } from '../config';

const initialState = {
  done: false,
  loading: false,
  errorRequest: false,
  error: null,
  info: {},
};

export default function setBranchOrderReducer(state = initialState, action) {
  switch (action.type) {
    case constants.POST_BRANCH_ORDER:
      return { ...state, loading: true, errorRequest: false, error: null };
    case constants.POST_BRANCH_ORDER_SUCCESS: {
      return {
        ...state,
        loading: false,
        done: true,
        error: null,
        info: {
          ...action.payload,
        },
      };
    }
    case constants.POST_BRANCH_ORDER_FAIL:
      return { ...state, loading: false, errorRequest: true, error: { ...action.error } };
    case constants.PUT_BRANCH_ORDER:
      return { ...state, loading: true, errorRequest: false, error: null, done: false };
    case constants.PUT_BRANCH_ORDER_SUCCESS: {
      return {
        ...state,
        loading: false,
        done: true,
        error: null,
        info: {
          ...action.payload,
        },
      };
    }
    case constants.PUT_BRANCH_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        errorRequest: true,
        error: { ...action.error },
        done: true,
      };

    case constants.RESET_BRANCH_ORDER:
      return initialState;
    case constants.GET_BRANCH_ORDER_FROM_SOCKETS:
      return {
        ...state,
        loading: false,
        done: true,
        info: {
          ...action.data.order,
          status: action.data.status,
          payment_intent_id: action.data.payment_intent_id,
        },
      };
    default:
      return state;
  }
}
